// sort-imports-ignore
// Capture must initialize before application dependencies emit startup diagnostics.
import "./shared/services/local-logs";
import "./shared/services/frontend-logs";
import App from "./App";
import { AuthContextProvider } from "./auth/state/AuthContext";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { log } from "./shared/services/debug-logger";
import { datadogRum } from "@datadog/browser-rum";
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";

// During testing we don't want to execute RUM calls.
// Adds to the bills for no reason + the call fail, spamming errors in Cypress.
const enableRUM = window.Cypress ? window.Cypress.env("enableDatadogRUM") : true;

if (enableRUM) {
  datadogRum.init({
    applicationId: process.env.REACT_APP_RUM_APP_ID ?? "",
    clientToken: process.env.REACT_APP_RUM_CLIENT_TOKEN ?? "",
    site: "datadoghq.com",
    service: process.env.REACT_APP_RUM_SERVICE,
    env: process.env.REACT_APP_RUM_ENV,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 20,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    defaultPrivacyLevel: "mask-user-input",
  });

  // Experimental. Maybe we will need to disable it on prod.
  // I discussed with Mark Stanton from CCM and he says the data is
  // anonimised so there's no infringement on cookie policy.
  datadogRum.startSessionReplayRecording();
}

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
log("main - INIT");

root.render(
  <Router>
    <AuthContextProvider>
      <App />
    </AuthContextProvider>
  </Router>,
);

// Service workers are disabled; remove any previously installed worker.
serviceWorkerRegistration.unregister();
reportWebVitals();
